<template>
    <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'0'"></HeaderNav>
    <div id="acctpage">
       <!-- 搜索栏 -->
       <div class="serchbox">
            <div class="serch_form">
                <div class="serch_item">
                   <label>起始日期：</label>
                   <input type="date" v-model="queryParams.startDate">
                </div>
                <div class="serch_item">
                   <label>结束日期：</label>
                   <input type="date" v-model="queryParams.endDate">
                </div>
                <div class="serch_item">
                   <label>收支类型：</label>
                   <select v-model="queryParams.dcFlag">
                      <option value="">全部</option>
                      <option value="C">收入</option>
                      <option value="D">支出</option>
                   </select>
                </div>
            </div>
            <div class="serch_btn">
               <a href="javascript:void(0)" class="btn-search" @click="handleSearch">查询</a>
               <a href="javascript:void(0)" class="btn-reset" @click="handleReset">重置</a>
            </div>
       </div>

       <!-- 表格区域 -->
       <div class="tablelist">
          <div class="content">
              <div class="tablebox">
                  <!-- 表头 -->
                  <div class="table-header">
                     <div class="th-col th-index">序号</div>
                     <div class="th-col th-time">交易时间</div>
                     <div class="th-col th-date">交易日期</div>
                     <div class="th-col th-amount">交易金额</div>
                     <div class="th-col th-type">收支类型</div>
                     <div class="th-col th-remark">备注</div>
                  </div>
                  <!-- 数据行 -->
                  <div class="table-row" v-for="(item, index) in dataList" :key="index">
                     <div class="td-col th-index">
                        <span class="row-num">{{ (pageNum - 1) * pageSize + index + 1 }}</span>
                     </div>
                     <div class="td-col th-time">
                        <span class="cell-time">{{ formatTime(item.creatTime) }}</span>
                     </div>
                     <div class="td-col th-date">
                        <span class="cell-date">{{ formatDate(item.txnDate) }}</span>
                     </div>
                     <div class="td-col th-amount">
                        <span class="cell-amount" :class="item.dcFlag == 'C' ? 'amount-in' : 'amount-out'">
                            {{ item.dcFlag == 'C' ? '+' : '-' }}¥{{ fenToYuan(item.amt) }}
                        </span>
                     </div>
                     <div class="td-col th-type">
                        <span class="type-tag" :class="item.dcFlag == 'C' ? 'tag-in' : 'tag-out'">
                            {{ item.dcFlag == 'C' ? '收入' : '支出' }}
                        </span>
                     </div>
                     <div class="td-col th-remark">
                        <span class="cell-remark">{{ item.remark || '-' }}</span>
                     </div>
                  </div>
                  <div class="no_date" v-if="dataList.length == 0">
                     暂无数据
                  </div>
              </div>
          </div>
          <!-- 分页 -->
          <div class="footer" v-if="pagesTotal > 1">
              <div class="page-wrap">
                 <span class="page-total">共 {{ total }} 条，{{ pagesTotal }} 页</span>
                 <div class="pagebtn">
                    <a href="javascript:void(0)" @click="prepage()" class="prebtn" :class="{'disabled': pageNum == 1}">&laquo; 上一页</a>
                    <a href="javascript:void(0)" 
                       v-for="item in pagebtnList" 
                       :key="item"
                       @click="pageselect(item)" 
                       :class="{'active_page': pageNum == item, 'is_sheng': item == '...'}">
                       {{ item }}
                    </a>
                    <a href="javascript:void(0)" @click="nextpage()" class="nextbtn" :class="{'disabled': pageNum == pagesTotal}">下一页 &raquo;</a>
                 </div>
              </div>
         </div>
      </div>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import HeaderNav from '../common/HeaderNav.vue';
import { selectAcctNobookPage } from "@/tools/Api";

export default {
    name: "TransactionDetail",
    components: {
        HeaderNav
    },
    data() {
        return {
            dataList: [],
            pageNum: 1,
            pageSize: 10,
            pagesTotal: 0,
            total: 0,
            pagebtnList: [],

            queryParams: {
                startDate: '',
                endDate: '',
                dcFlag: ''
            }
        }
    },
    mounted() {
        this.getPageList();
    },
    methods: {
        // 获取当月第一天作为默认起始日期
        getDefaultStartDate() {
            const now = new Date();
            const y = now.getFullYear();
            const m = String(now.getMonth() + 1).padStart(2, '0');
            return y + '-' + m + '-01';
        },
        // 分转元
        fenToYuan(fen) {
            return ((fen || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 格式化时间
        formatTime(creatTime) {
            if (!creatTime) return '-';
            const t = '' + creatTime;
            if (t.length >= 19) return t.substring(0, 19);
            if (t.length >= 16) return t.substring(0, 16);
            return t;
        },
        // 格式化日期 20260827 -> 2026-08-27
        formatDate(txnDate) {
            if (!txnDate) return '-';
            const d = '' + txnDate;
            if (d.length == 8) {
                return d.substring(0, 4) + '-' + d.substring(4, 6) + '-' + d.substring(6, 8);
            }
            return d;
        },
        // 获取列表
        getPageList() {
            const params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                ...this.queryParams
            };
            // 日期格式转为 yyyyMMdd
            if (params.startDate) {
                params.startDate = params.startDate.replace(/-/g, '');
            }
            if (params.endDate) {
                params.endDate = params.endDate.replace(/-/g, '');
            }
            // 过滤空值
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] == null) {
                    delete params[key];
                }
            });

            selectAcctNobookPage(params).then(res => {
                if (res.status == 0) {
                    this.dataList = res.data.list || res.data || [];
                    if (res.data.pageNum) {
                        this.pageNum = res.data.pageNum;
                        this.pagesTotal = res.data.pages;
                        this.total = res.data.total;
                    }
                    this.pageshowbtn();
                }
            }).catch(err => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
            });
        },
        handleSearch() {
            this.pageNum = 1;
            this.getPageList();
        },
        handleReset() {
            this.queryParams = {
                startDate: '',
                endDate: '',
                dcFlag: ''
            };
            this.handleSearch();
        },
        // 分页
        pageshowbtn() {
            this.pagebtnList = [];
            if (this.pagesTotal < 7) {
                for (var i = 0; i < this.pagesTotal; i++) {
                    this.pagebtnList.push(i + 1);
                }
            } else {
                if (this.pageNum < 5) {
                    this.pagebtnList = [1, 2, 3, 4, 5, '...', this.pagesTotal];
                } else if (this.pageNum > this.pagesTotal - 5) {
                    this.pagebtnList = [1, '...', this.pagesTotal - 4, this.pagesTotal - 3, this.pagesTotal - 2, this.pagesTotal - 1, this.pagesTotal];
                } else {
                    this.pagebtnList = [1, '...', this.pageNum - 1, this.pageNum, this.pageNum + 1, '...', this.pagesTotal];
                }
            }
        },
        pageselect(pgn) {
            if (pgn == "...") return;
            this.pageNum = pgn;
            this.getPageList();
        },
        nextpage() {
            if (this.pageNum != this.pagesTotal) {
                this.pageNum += 1;
            }
            this.getPageList();
        },
        prepage() {
            if (this.pageNum != 1) {
                this.pageNum -= 1;
            }
            this.getPageList();
        },
    }
}
</script>

<style scoped>
#acctpage {
    width: 100%;
    height: calc(100% - 40px);
    padding: 24px 40px;
    overflow-y: auto;
    box-sizing: border-box;
    background: #f5f6f8;
}

/* ===== 搜索栏 ===== */
#acctpage .serchbox {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    margin-bottom: 20px;
}
#acctpage .serch_form {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
#acctpage .serch_item {
    display: flex;
    align-items: center;
}
#acctpage .serch_item label {
    font-size: 14px;
    color: #555;
    margin-right: 8px;
    white-space: nowrap;
    font-weight: 500;
}
#acctpage .serch_item input,
#acctpage .serch_item select {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    color: #333;
    min-width: 150px;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: #fff;
}
#acctpage .serch_item input:focus,
#acctpage .serch_item select:focus {
    border-color: #12ab04d4;
    box-shadow: 0 0 0 3px rgba(18,171,4,0.08);
}
#acctpage .serch_btn {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
}
#acctpage .serch_btn a {
    text-decoration: none;
    height: 36px;
    line-height: 36px;
    padding: 0 18px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    display: inline-block;
    text-align: center;
}
#acctpage .serch_btn .btn-search {
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    color: #fff;
    border: none;
    box-shadow: 0 3px 8px rgba(18,171,4,0.2);
}
#acctpage .serch_btn .btn-search:hover {
    box-shadow: 0 5px 12px rgba(18,171,4,0.3);
    transform: translateY(-1px);
}
#acctpage .serch_btn .btn-reset {
    background-color: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
}
#acctpage .serch_btn .btn-reset:hover {
    color: #12ab04d4;
    border-color: #12ab04d4;
    background-color: #f0f9eb;
}

/* ===== 表格 ===== */
#acctpage .tablelist {
    width: 100%;
}
#acctpage .tablelist .content {
    width: 100%;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.05);
    overflow: hidden;
}
#acctpage .tablelist .content .tablebox {
    width: 100%;
}
/* 表头 */
.table-header {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 46px;
    background: #fafbfc;
    border-bottom: 1px solid #ebeef5;
}
.table-header .th-col {
    font-size: 13px;
    font-weight: 600;
    color: #909399;
}
/* 数据行 */
.table-row {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 54px;
    border-bottom: 1px solid #f5f5f5;
    transition: background 0.2s;
}
.table-row:hover {
    background: #fafbfc;
}
.table-row:last-child {
    border-bottom: none;
}
/* 列宽分配 */
.th-index, .td-col.th-index { width: 60px; flex-shrink: 0; text-align: center; }
.th-time, .td-col.th-time { flex: 2; }
.th-date, .td-col.th-date { flex: 1.5; }
.th-amount, .td-col.th-amount { flex: 1.5; text-align: right; }
.th-type, .td-col.th-type { width: 90px; text-align: center; flex-shrink: 0; }
.th-remark, .td-col.th-remark { flex: 2; }

/* 单元格样式 */
.row-num {
    display: inline-block;
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #f4f4f5;
    border-radius: 6px;
    font-size: 12px;
    color: #999;
    font-weight: 500;
}
.cell-time {
    font-size: 14px;
    color: #333;
}
.cell-date {
    font-size: 14px;
    color: #555;
}
.cell-amount {
    font-size: 15px;
    font-weight: 600;
    font-family: 'Courier New', monospace;
}
.amount-in { color: #41924e; }
.amount-out { color: #d9534f; }
.type-tag {
    display: inline-block;
    padding: 3px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}
.tag-in {
    background: #f0f9eb;
    color: #41924e;
    border: 1px solid #b3e19d;
}
.tag-out {
    background: #fef0f0;
    color: #d9534f;
    border: 1px solid #fbc4c4;
}
.cell-remark {
    font-size: 13px;
    color: #888;
}

/* 暂无数据 */
.no_date {
    width: 100%;
    text-align: center;
    padding: 60px 0;
    color: #ccc;
    font-size: 15px;
}

/* ===== 分页 ===== */
#acctpage .tablelist .footer {
    width: 100%;
    padding: 16px 0;
}
#acctpage .tablelist .footer .page-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
#acctpage .tablelist .footer .page-total {
    font-size: 13px;
    color: #909399;
    flex-shrink: 0;
}
#acctpage .tablelist .footer .pagebtn {
    display: flex;
    align-items: center;
    gap: 4px;
}
#acctpage .tablelist .footer .pagebtn a {
    text-decoration: none;
    color: #606266;
    display: inline-block;
    font-size: 13px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
}
#acctpage .tablelist .footer .pagebtn a:hover {
    color: #12ab04d4;
    border-color: #12ab04d4;
}
#acctpage .tablelist .footer .pagebtn a.nextbtn,
#acctpage .tablelist .footer .pagebtn a.prebtn {
    border: 1px solid #dcdfe6;
    background: #fff;
    color: #606266;
    padding: 0 12px;
    min-width: auto;
}
#acctpage .tablelist .footer .pagebtn a.nextbtn:hover,
#acctpage .tablelist .footer .pagebtn a.prebtn:hover {
    color: #12ab04d4;
    border-color: #12ab04d4;
}
#acctpage .tablelist .footer .pagebtn a.active_page {
    background: linear-gradient(135deg, #12ab04d4, #0d8a03);
    color: #fff;
    border-color: #12ab04d4;
    box-shadow: 0 2px 6px rgba(18,171,4,0.25);
    font-weight: 600;
}
#acctpage .tablelist .footer .pagebtn a.active_page:hover {
    color: #fff;
}
#acctpage .tablelist .footer .pagebtn a.is_sheng {
    border: none;
    background-color: transparent;
    cursor: default;
}
#acctpage .tablelist .footer .pagebtn a.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
